module.exports = __webpack_public_path__ + "media/application/images/cost-to-serve-bg-cd7803f46070e0a8c9be4e7ce862da88.png";